import { Route, Navigate } from 'react-router-dom';

import ContentView from 'views/Content/ContentView';
import PagesView from 'views/Pages/PagesView';

import BuilderView from 'views/Builder/BuilderView';
import { getSharedRoutes } from './utils/sharedRoutesUtil';
import { ERouteContext, ESharedRoutes } from 'routes/types';

const portalLevelRoutes = () => (
  <Route path="portal/:portalId/*">
    {getSharedRoutes(ESharedRoutes.PLAYERS)}
    {getSharedRoutes(ESharedRoutes.LOCALIZATION)}
    {getSharedRoutes(ESharedRoutes.SETTINGS, ERouteContext.PORTAL)}
    <Route path="builder/*" element={<BuilderView />} />
    <Route path="pages/*" element={<PagesView />} />
    <Route path="content/*" element={<ContentView />} />
  </Route>
);

export default portalLevelRoutes;
